import { render, staticRenderFns } from "./setup-2fa.vue?vue&type=template&id=7db4e3cb&scoped=true&"
import script from "./setup-2fa.vue?vue&type=script&lang=js&"
export * from "./setup-2fa.vue?vue&type=script&lang=js&"
import style0 from "./setup-2fa.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./setup-2fa.vue?vue&type=style&index=1&id=7db4e3cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db4e3cb",
  null
  
)

export default component.exports